export default {
    accesos: [
        { route: 'dashboard', modulo: '' },

        { route: 'ventas', modulo: '' },
        { route: 'ventas/presupuestosinternos', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/ABM', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/usuarios', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/produccion', modulo: '' },
        { route: 'ventas/presupuestosinternos/ordenestrabajo/:id/produccion', modulo: '' },
        { route: '', modulo: 'PresupuestosInternosAddBrief' },
        { route: '', modulo: 'PresupuestosInternosConsultarBrief' },
        { route: 'ventas/presupuestos-cancelados', modulo: '' },
        { route: 'ventas/subtrabajos', modulo: '' },
        { route: 'ventas/certificados-servicio', modulo: '' },
        { route: 'ventas/certificados-servicio/:id', modulo: '' },
        { route: 'ventas/certificados-servicio/presupuesto/:presupuestoId/add', modulo: '' },
        { route: 'ventas/certificados-servicio/:id/edit', modulo: '' },
        { route: 'ventas/facturas', modulo: '' },
        { route: 'ventas/facturas/:id', modulo: '' },
        { route: '', modulo: 'VentasValidarAFIP' },

        { route: 'disenio', modulo: '' },
        { route: 'disenio/briefs', modulo: '' },
        { route: 'disenio/briefs/add', modulo: '' },
        { route: 'disenio/briefs/:id/edit', modulo: '' },
        { route: 'disenio/briefs/:id/adicionales', modulo: '' },
        { route: 'disenio/briefs/:id/cambios', modulo: '' },
        { route: 'disenio/briefs/:id', modulo: '' },
        { route: '', modulo: 'BriefsCancelar' },
        { route: '', modulo: 'BriefsAgregarPresupuesto' },
        // { route: '', modulo: 'BriefsSolicitudesCambios' },
        { route: '', modulo: 'BriefsEntregasValidacionInformacion' },
        { route: '', modulo: 'BriefsEntregasSolicitudCambios' },

        { route: 'logistica', modulo: '' },
        { route: 'logistica/remitos', modulo: '' },
        { route: 'logistica/remitos/add', modulo: '' },
        { route: 'logistica/remitos/:id/duplicado', modulo: '' },
        { route: 'logistica/remitos/:id', modulo: '' },
        { route: 'logistica/destinos', modulo: '' },
        { route: 'logistica/destinos/:id', modulo: '' },
        { route: 'logistica/destinos/:id/ABM', modulo: '' },
        
        { route: 'clientes', modulo: '' },
        { route: 'clientes/clientes', modulo: '' },
        { route: 'clientes/clientes/:id', modulo: '' },
        { route: 'clientes/clientes/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id/ABM', modulo: '' },
    
        { route: 'clientes/cuentacorriente', modulo: '' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },
        { route: '', modulo: 'OrdenesProveedoresAgregarEvaluacion' },
        { route: 'proveedores/evaluaciones-proveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores/:id', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/bancos', modulo: '' },
        { route: 'tablas/bancos/:id', modulo: '' },
        { route: 'tablas/bancos/:id/ABM', modulo: '' },
        { route: 'tablas/paises', modulo: '' },
        { route: 'tablas/provincias', modulo: '' },
        { route: 'tablas/localidades', modulo: '' },
        { route: 'tablas/localidades/:id', modulo: '' },
        { route: 'tablas/localidades/:id/ABM', modulo: '' },
        
        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'reportes', modulo: '' },
        { route: 'reportes/ventas', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-aperturas-cierres', modulo: '' },
    ]
}
